import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { MedigiComponentCopyService } from '../../../medigi/medigi-component-copy.service';

@Component({
  selector: 'app-employee-card',
  templateUrl: './employee-card.component.html',
  styleUrls: ['./employee-card.component.scss'],
})
export class EmployeeCardComponent implements OnInit {
  employees;

  constructor(
    private medigiCopyService: MedigiComponentCopyService,
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  ngOnInit() {
    this.getEmployees();
  }

  getEmployees() {
    this.employees = this.medigiCopyService.leardershipTeam;
  }

  goToSocial(index) {
    window.open(this.employees[index].socialUrl, '_blank');
  }

  sendToGa(eventName, eventCategory) {
    this.googleAnalyticsService.eventEmitter(eventCategory, eventName);
  }
}
